import React, { useCallback } from "react";
import {
  PopoverListItem,
  PopoverListItemTitle,
} from "../../../../components/mobile/Popover";
import { AHSeparator, Box } from "arkh";
import { UserLoggedInNavigatorNavigationProp } from "../../../../TopLevelNavigators/UserLoggedIn/UserLoggedInNavigatorParamList";
import { StorecastHeaderButton } from "./StorecastHeaderButton";
import { PopoverButton } from "../../../../common/PopoverButton";
import { useIntlTokens } from "../../../../components/mobile/useIntlTokens";
import { FormattedMessage } from "react-intl";

const STORESPRINT_UPDATES = (
  <FormattedMessage
    defaultMessage="StoreSprint updates"
    description="TeamMoreMenu Store"
  />
);

export function StorecastMoreButton(props: {
  navigation: UserLoggedInNavigatorNavigationProp<"Dashboard">;
  isCompact: boolean;
}) {
  const intl_tokens = useIntlTokens();
  const popoverContent = useCallback(
    (close: () => void) => (
      <Box space="small">
        <PopoverListItem
          onPress={() => {
            close();
            props.navigation.navigateDeprecated("Files", {});
          }}
          leftIcon="files"
        >
          <PopoverListItemTitle>{intl_tokens.Files}</PopoverListItemTitle>
        </PopoverListItem>
        <AHSeparator spaceVertical="xsmall" />
        <PopoverListItem
          onPress={() => {
            close();
            props.navigation.navigateDeprecated("WebView", {
              url: "https://www.storesprint.com/support",
            });
          }}
          leftIcon="help"
        >
          <PopoverListItemTitle>{intl_tokens.Help}</PopoverListItemTitle>
        </PopoverListItem>
        <PopoverListItem
          onPress={() => {
            close();
            props.navigation.navigateDeprecated("WebView", {
              url: "https://www.storesprint.com/in-app-update",
            });
          }}
          leftIcon="storesprint-update"
        >
          <PopoverListItemTitle>{STORESPRINT_UPDATES}</PopoverListItemTitle>
        </PopoverListItem>
      </Box>
    ),
    [props.navigation, intl_tokens.Files, intl_tokens.Help]
  );

  const button = useCallback(
    (open: () => void) => {
      return (
        <StorecastHeaderButton
          onPress={open}
          icon="more-outlined"
          title={props.isCompact ? undefined : intl_tokens.More}
        />
      );
    },
    [intl_tokens.More, props.isCompact]
  );

  return (
    <PopoverButton
      popoverWidth={props.isCompact ? 200 : 250}
      popoverContent={popoverContent}
    >
      {button}
    </PopoverButton>
  );
}
